import React, { useEffect, useState } from "react";
import { IPetsyHelpPopupProps } from "./PetsyHelpPopup.types";
import { Modal, Button } from "react-bootstrap";
import "./PetsyHelpPopup.scss";
import _ from "lodash";

export default function PetsyHelpPopup(props: IPetsyHelpPopupProps) {
  const [show, setShow] = useState(false);

  function modalClose() {
    setShow(false);
  }

  function modalOpen(e: React.MouseEvent) {
    e.preventDefault();
    setShow(true);
  }

  return (
    <>
      {/* 👉 Link để mở modal */}
      <div className="flc_petsy-help-link">
        <a href="#" onClick={modalOpen} className="flc_petsy-help-link-text">
          {props.linkText || "Open Help"}
        </a>
      </div>

      <Modal
        className="flc_petsy-help-popup"
        show={show}
        onHide={modalClose}
        backdrop="static"
        keyboard={false}
        fullscreen="sm-down"
        centered
      >
        <Modal.Header closeButton>
          <div className="modal-header-text">Not sure exactly or your pet isn’t born yet?</div>
        </Modal.Header>
        <div className="modal-hr">
          <hr />
        </div>
        <Modal.Body className="text-center">
          <div className="mb-5 modal-box-content"> 
            <h3 className="modal-content-title">What if I don't know my pet's birthday?</h3>
            <p className="modal-content-text">Use your best estimate for now. You can update this later once you know the exact date.</p>
          </div>
          <div className="mb-5 modal-box-content"> 
            <h3 className="modal-content-title">Pet not born yet?</h3>
            <p className="modal-content-text">Pets need to be at least 6 weeks old for cover to begin. You can apply from 2 weeks of age and set the policy start date up to 30 calendar days ahead. This way, coverage can start as soon as your pet turns 6 weeks, and exclusion periods for injury and illness may already be passed by the time your new pet comes home.</p>
          </div>
          <div className="modal-box-content"> 
            <h3 className="modal-content-title">How it affects your cover</h3>
            <p className="modal-content-text">Your pets age helps us calculate premiums and determine which benefits they're eligible for, including Optional Extra Benefits only available for pets under 3 years old. Having accurate information on your policy is essential to ensure smooth processing of any claims and an incorrect birthday could impact your ongoing cover.</p>
          </div>

        </Modal.Body>
        <Modal.Footer>
          <div className="md-footer-text">
            Need help updating your pet's date of birth? <br />
            Contact us on 1300 952 790.
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
